import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../store';

interface State {
  industryApplicationId: number | undefined;
  chartType: string;
}

interface ActionPayload {
  industryApplicationId: number | undefined;
  currentTab?: string;
}

const initialState: State = {
  industryApplicationId: 0,
  chartType: '',
};

export const setIndustryApplicationId = createAsyncThunk(
  'AssetAnalysis/setIndustryApplicationId',
  async (payload: ActionPayload) => {
    // Return the payload to be used in the reducer
    return await Promise.resolve(payload);
  },
);

const AssetAnalysisSlice = createSlice({
  name: 'AssetAnalysis',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setIndustryApplicationId.fulfilled, (state, action) => {
      const { industryApplicationId, currentTab } = action.payload;
      state.industryApplicationId = industryApplicationId;

      if (currentTab) {
        if (currentTab === 'tests') {
          if (industryApplicationId == 4) {
            state.chartType = 'esp-well-tests';
          } else if (industryApplicationId == 7) {
            state.chartType = 'gl-well-tests';
          } else {
            state.chartType = '';
          }
        } else if (currentTab === 'charts' || currentTab === 'notesAndTasks') {
          // For notesAndTasks, use the same chart types as charts since TaskDetailsWidget needs the same configuration
          if (industryApplicationId == 3) {
            state.chartType = 'rl-well-charts';
          } else if (industryApplicationId == 4) {
            state.chartType = 'esp-well-charts';
          } else if (industryApplicationId == 7) {
            state.chartType = 'gl-well-charts';
          } else if (industryApplicationId == 5) {
            state.chartType = 'pcp-well-charts';
          } else if (industryApplicationId == 6) {
            state.chartType = 'gapl-well-charts';
          } else if (industryApplicationId == 16) {
            state.chartType = 'pagl-well-charts';
          } else if (industryApplicationId == 18) {
            state.chartType = 'facility-well-charts';
          } else {
            state.chartType = '';
          }
        }
      }
    });
  },
});

export const industryApplicationId = (state: RootState) => state.AssetAnalysis.industryApplicationId;
export default AssetAnalysisSlice.reducer;
